'use strict';
/* ============================================
   JM Collection Filter — Dropdown & Search
   Jeans Manufaktur · jm-2.0.18
   ============================================ */

(function () {
  /* ---- helpers ---- */
  var _jmDrawerLocked = false;
  function lockScroll() {
    document.body.style.overflow = 'hidden';
    _jmDrawerLocked = true;
  }
  function unlockScroll() {
    if (!_jmDrawerLocked) return;
    document.body.style.overflow = '';
    _jmDrawerLocked = false;
  }

  function closeAllPanels(except) {
    document.querySelectorAll('.jm-cf__panel.is-open').forEach(function (p) {
      if (p === except) return;
      p.classList.remove('is-open');
      var btn = p.closest('.jm-cf__dropdown');
      if (btn) btn = btn.querySelector('[data-jm-toggle]');
      if (btn) btn.classList.remove('is-open');
    });
  }

  /* ---- Collapsible group overflow detection ----
     Shows/hides the fade overlay + toggle button based on whether
     .jm-cf__group-options content exceeds its max-height. */
  function checkGroupOverflow() {
    document.querySelectorAll('.jm-cf__group').forEach(function (group) {
      var opts = group.querySelector('.jm-cf__group-options');
      var fade = group.querySelector('.jm-cf__group-fade');
      var toggle = group.querySelector('.jm-cf__group-toggle');
      if (!opts || !fade || !toggle) return;

      if (group.closest('.jm-cf__primary--compact-layout')) {
        fade.classList.remove('is-visible');
        toggle.classList.remove('is-visible');
        return;
      }

      /* If expanded, temporarily collapse to measure real overflow.
         Clear inline max-height, suppress transitions, remove is-expanded,
         then restore everything after measuring. */
      var wasExpanded = group.classList.contains('is-expanded');
      if (wasExpanded) {
        opts.style.maxHeight = '';
        opts.style.transition = 'none';
        group.classList.remove('is-expanded');
        opts.offsetHeight; /* force synchronous reflow so measurement is accurate */
      }

      var collapsedScrollHeight = opts.scrollHeight;
      var overflows = collapsedScrollHeight > opts.clientHeight + 2; /* 2px tolerance */

      var filterType = group.getAttribute('data-filter-type');
      if (filterType === 'fit' && window.innerWidth >= 750) {
        var fitItems = opts.querySelectorAll('filter-item').length;
        /* 4 columns × 2 rows — no expand control when everything fits */
        if (fitItems > 0 && fitItems <= 8) {
          overflows = false;
        }
      }

      if (wasExpanded) {
        group.classList.add('is-expanded');
        /* On mobile, set explicit pixel max-height (from collapsed measurement)
           instead of relying on CSS "none" which causes double-height on mobile.
           On desktop, clear inline style so CSS handles it. */
        opts.style.maxHeight = (window.innerWidth <= 749)
          ? collapsedScrollHeight + 'px'
          : '';
        opts.offsetHeight; /* force reflow before re-enabling transition */
        opts.style.transition = '';
      }

      /* Show toggle only if content actually overflows in collapsed state */
      fade.classList.toggle('is-visible', overflows && !wasExpanded);
      toggle.classList.toggle('is-visible', overflows);
    });
  }

  /* Expose globally so collection.js can re-trigger after AJAX re-render */
  window.jmCfCheckOverflow = function () {
    /* Delay one frame to ensure CSS layout (max-height) is applied */
    requestAnimationFrame(function () {
      requestAnimationFrame(checkGroupOverflow);
    });
  };

  /* ---- Compact primary: First-Fit Decreasing row pack (tablet/desktop) ---- */
  function readPackWidth(el) {
    var rectW = el.getBoundingClientRect().width;
    if (rectW >= 1) return Math.ceil(rectW);
    var basis = getComputedStyle(el).getPropertyValue('--jm-cf-flex-basis').trim();
    var parsed = parseFloat(basis);
    if (!isNaN(parsed) && parsed > 0) return Math.ceil(parsed);
    var attr = parseInt(el.getAttribute('data-pack-width'), 10);
    return isNaN(attr) || attr < 1 ? 180 : attr;
  }

  function packCompactPrimary(root) {
    if (window.innerWidth < 750) return;
    root = root || document;
    var primary = root.querySelector
      ? root.querySelector('.jm-cf__primary--compact-layout')
      : null;
    if (!primary) return;

    var groups = primary.querySelectorAll('.jm-cf__group--compact');
    if (!groups.length) return;

    var gap = parseFloat(getComputedStyle(primary).gap);
    if (isNaN(gap)) gap = 10;
    var containerWidth = primary.clientWidth;
    if (containerWidth < 1) return;

    var items = Array.prototype.map.call(groups, function (el) {
      return { el: el, width: readPackWidth(el) };
    });
    items.sort(function (a, b) {
      return b.width - a.width;
    });

    var rows = [];
    items.forEach(function (item) {
      var placed = false;
      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        var extra = row.used > 0 ? gap : 0;
        if (row.used + extra + item.width <= containerWidth + 0.5) {
          row.items.push(item);
          row.used += extra + item.width;
          placed = true;
          break;
        }
      }
      if (!placed) {
        rows.push({ items: [item], used: item.width });
      }
    });

    var ordered = [];
    rows.forEach(function (row) {
      row.items.forEach(function (item) {
        ordered.push(item.el);
      });
    });

    var children = primary.children;
    var sameOrder = ordered.length === children.length;
    if (sameOrder) {
      for (var i = 0; i < ordered.length; i++) {
        if (ordered[i] !== children[i]) {
          sameOrder = false;
          break;
        }
      }
    }
    if (sameOrder) return;

    var frag = document.createDocumentFragment();
    ordered.forEach(function (el) {
      frag.appendChild(el);
    });
    primary.appendChild(frag);
  }

  window.jmCfPackCompactPrimary = function (root) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        packCompactPrimary(root);
      });
    });
  };

  var packDebounceTimer;
  function scheduleCompactPack(root) {
    clearTimeout(packDebounceTimer);
    packDebounceTimer = setTimeout(function () {
      window.jmCfPackCompactPrimary(root);
      checkGroupOverflow();
    }, 120);
  }

  /* Run overflow check dynamically with ResizeObserver to handle window resize and late font/image loading */
  var resizeObserver = new ResizeObserver(function (entries) {
    var needsPack = false;
    entries.forEach(function (entry) {
      if (entry.target.closest && entry.target.closest('.jm-cf__primary--compact-layout')) {
        needsPack = true;
      }
    });
    if (needsPack) {
      scheduleCompactPack(document);
    } else {
      window.jmCfCheckOverflow();
    }
  });
  var observedGroups = [];
  var observedCompactPrimaries = [];

  function hasFilterGroups(root) {
    return !!root.querySelector('.jm-cf__group-options');
  }

  /* Observe each group options container if it exists */
  function observeGroups(root) {
    root = root || document;
    root.querySelectorAll('.jm-cf__group-options').forEach(function (opts) {
      if (observedGroups.indexOf(opts) !== -1) return;
      observedGroups.push(opts);
      resizeObserver.observe(opts);
    });
    observedGroups.forEach(function (opts) {
      if (!document.contains(opts)) {
        resizeObserver.unobserve(opts);
      }
    });
    observedGroups = observedGroups.filter(function (opts) {
      return document.contains(opts);
    });
    var compactPrimary = root.querySelector('.jm-cf__primary--compact-layout');
    if (compactPrimary && observedCompactPrimaries.indexOf(compactPrimary) === -1) {
      observedCompactPrimaries.push(compactPrimary);
      resizeObserver.observe(compactPrimary);
    }
    observedCompactPrimaries = observedCompactPrimaries.filter(function (el) {
      return document.contains(el);
    });
    window.jmCfPackCompactPrimary(root);
    window.jmCfCheckOverflow();
  }

  window.jmCfRefresh = function (root) {
    root = root || document;
    /* After AJAX re-render the drawer DOM may be replaced — restore scroll only if we locked it */
    if (!document.querySelector('.jm-cf__secondary.is-open')) {
      unlockScroll();
    }
    if (root !== document && !hasFilterGroups(root)) return;
    requestAnimationFrame(function () {
      observeGroups(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.jmCfRefresh(document);
    });
  } else {
    window.jmCfRefresh(document);
  }

  /* Close drawer and restore scroll when viewport crosses desktop breakpoint */
  var desktopMq = window.matchMedia('(min-width: 1025px)');
  function onBreakpointCross() {
    if (desktopMq.matches) {
      var secondary = document.querySelector('.jm-cf__secondary');
      var overlay = document.querySelector('.jm-cf__drawer-overlay');
      if (secondary) secondary.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      unlockScroll();
    }
  }
  desktopMq.addEventListener('change', onBreakpointCross);

  var compactPackMq = window.matchMedia('(min-width: 750px)');
  compactPackMq.addEventListener('change', function () {
    scheduleCompactPack(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    window.jmCfRefresh(event.target);
  });

  document.addEventListener('theme:dom-updated', function (event) {
    if (event.detail && event.detail.container) {
      window.jmCfRefresh(event.detail.container);
    }
  });

  /* ---- event-delegation on document (survives DOM replacement) ---- */

  /* Toggle expand/collapse — all groups at once */
  document.addEventListener('click', function (e) {
    var expandBtn = e.target.closest('[data-jm-expand]');
    if (expandBtn) {
      e.stopPropagation();
      var clickedGroup = expandBtn.closest('.jm-cf__group');
      if (!clickedGroup) return;

      /* Determine direction from clicked group, then apply to ALL groups */
      var willExpand = !clickedGroup.classList.contains('is-expanded');
      var isMobile = window.innerWidth <= 749;

      document.querySelectorAll('.jm-cf__group').forEach(function (group) {
        var opts = group.querySelector('.jm-cf__group-options');
        if (willExpand) {
          /* Measure scrollHeight BEFORE adding is-expanded so overflow:hidden
             is still in place and scrollHeight reflects full content height */
          if (isMobile && opts) {
            opts.style.maxHeight = opts.scrollHeight + 'px';
          }
          group.classList.add('is-expanded');
        } else {
          group.classList.remove('is-expanded');
          /* Clear inline max-height so CSS max-height (180px) takes over */
          if (opts) opts.style.maxHeight = '';
        }
      });

      /* Update ALL toggle labels */
      document.querySelectorAll('[data-jm-expand] span').forEach(function (label) {
        label.textContent = willExpand ? 'Weniger anzeigen' : 'Mehr anzeigen';
      });

      /* Re-check overflow so buttons hide for groups that fully fit */
      checkGroupOverflow();
      return;
    }

    /* Mobile: toggle entire primary filter section */
    var mobileBtn = e.target.closest('[data-jm-mobile-filter]');
    if (mobileBtn) {
      e.stopPropagation();
      var primary = document.querySelector('.jm-cf__primary');
      if (!primary) return;
      var isOpen = primary.classList.toggle('is-open');
      mobileBtn.classList.toggle('is-open', isOpen);
      var label = mobileBtn.querySelector('span');
      if (label) {
        label.textContent = isOpen ? 'Filter ausblenden' : 'Filter anzeigen';
      }
      return;
    }

    /* Secondary filter drawer: open/close */
    var drawerTrigger = e.target.closest('[data-jm-secondary-drawer]');
    if (drawerTrigger) {
      e.stopPropagation();
      var secondary = document.querySelector('.jm-cf__secondary');
      var overlay = document.querySelector('.jm-cf__drawer-overlay');
      if (secondary) secondary.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      lockScroll();
      return;
    }

    var drawerClose = e.target.closest('[data-jm-drawer-close]');
    var overlayClick = e.target.closest('[data-jm-drawer-overlay]');
    if (drawerClose || overlayClick) {
      e.stopPropagation();
      var secondary = document.querySelector('.jm-cf__secondary');
      var overlay = document.querySelector('.jm-cf__drawer-overlay');
      if (secondary) secondary.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      unlockScroll();
      return;
    }

    /* Kundeninformationen: toggle "Mehr lesen" / "Weniger lesen" */
    var infoBtn = e.target.closest('[data-jm-info-toggle]');
    if (infoBtn) {
      e.stopPropagation();
      var infoBlock = infoBtn.closest('.jm-info-text');
      if (!infoBlock) return;
      var isExpanded = infoBlock.classList.toggle('is-expanded');
      infoBtn.setAttribute('aria-expanded', isExpanded);
      var label = infoBtn.querySelector('span');
      if (label) {
        label.textContent = isExpanded ? 'Weniger lesen' : 'Mehr lesen';
      }
      return;
    }
  });

  /* Toggle dropdown */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jm-toggle]');
    if (btn) {
      e.stopPropagation();
      var dropdown = btn.closest('.jm-cf__dropdown');
      if (!dropdown) return;
      var panel = dropdown.querySelector('.jm-cf__panel');
      if (!panel) return;
      var isOpen = panel.classList.contains('is-open');
      closeAllPanels(panel);
      if (isOpen) {
        panel.classList.remove('is-open');
        btn.classList.remove('is-open');
      } else {
        panel.classList.add('is-open');
        btn.classList.add('is-open');
        var search = panel.querySelector('.jm-cf__search');
        if (search) setTimeout(function () { search.focus(); }, 60);
      }
      return;
    }
    /* Outside click — close all */
    if (!e.target.closest('.jm-cf__dropdown')) {
      closeAllPanels(null);
    }
  });

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllPanels(null);
      var secondary = document.querySelector('.jm-cf__secondary');
      var overlay = document.querySelector('.jm-cf__drawer-overlay');
      if (secondary) secondary.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      unlockScroll();
    }
  });

  /* JM Price filter: submit on button click or Enter key */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#JmPriceFilter');
    if (!form) return;
    e.preventDefault();
    if (typeof eventCollectionShopify === 'undefined') return;
    var minInput = form.querySelector('.min-price-range');
    var maxInput = form.querySelector('.max-price-range');
    if (!minInput || !maxInput) return;
    var nameMin = minInput.getAttribute('name');
    var nameMax = maxInput.getAttribute('name');
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam(nameMin, queryString);
    queryString = eventCollectionShopify.removeParam(nameMax, queryString);
    var params = '';
    if (minInput.value) params += nameMin + '=' + minInput.value;
    if (maxInput.value) params += (params ? '&' : '') + nameMax + '=' + maxInput.value;
    var base = queryString.replace('?', '');
    var searchParams = base + (params ? (base ? '&' : '') + params : '');
    var url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  });

  /* Search filtering (delegated) */
  document.addEventListener('input', function (e) {
    if (!e.target.classList.contains('jm-cf__search')) return;
    var q = e.target.value.toLowerCase().trim();
    var list = e.target.closest('.jm-cf__panel');
    if (!list) return;
    list = list.querySelector('.jm-cf__list');
    if (!list) return;
    list.querySelectorAll('.jm-cf__list-item').forEach(function (item) {
      var text = (item.getAttribute('data-label') || item.textContent).toLowerCase();
      item.classList.toggle('is-hidden', q !== '' && text.indexOf(q) === -1);
    });
  });
})();
